import { Fragment } from 'react';


import styled from 'styled-components';

const ContactWrapper = styled.form`
    max-width: 400px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
    margin: 20px auto;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
`
const FormHeading = styled.h1`
    font-size: 26px;
    line-height: 1.4;
    margin: 0 0 20px;
    text-align: center;
    text-transform: capitalize;
`

const ContactData = props => {
    const { addressData  , paymentData  } = props

    return (
        <Fragment >
            <ContactWrapper>
                <FormHeading>address</FormHeading>
                {addressData()}
            </ContactWrapper>
            <ContactWrapper>
                <FormHeading>payment</FormHeading>
                {paymentData()}
            </ContactWrapper>
        </Fragment>
    )
}
export default ContactData;